import { SalesOrderMember } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1290. 受注案件メンバー登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_members
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  user_id: number;
};
const createSalesOrderMember = (props: Props): Promise<SalesOrderMember> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_members`,
    props
  );
};

export const useCreateSalesOrderMember = () => {
  return useMutation({
    mutationFn: createSalesOrderMember
  });
};
